module.exports = __webpack_public_path__ + "img/illustrator-something-wrong.1e0fe720.svg";